<template>
  <table class="striped">
    <thead>
      <th><i @click="clearSelection" title="Clear Selection" style="cursor: pointer" class="material-icons">clear</i></th>
      <th class="center-align">Community Name</th>
      <th class="center-align">Data Category</th>
      <th class="center-align">Data Availability</th>
      <th class="center-align">Community Data Summary</th>
    </thead>
    <tbody>
      <tr v-if="selectedMetricCategory !== null" v-for="(community, index) in communitiesForSelect">
        <td class="checkbox_container"><input :id="'com_' + index" type="checkbox" class="filled-in" :checked="community.selected" @click=checkboxClick(community)><label :for="'com_' + index"></label></td>
        <td class="center-align">{{ community.name }}</td>
        <td class="center-align">{{ selectedMetricCategory.display.split(' ')[0] }}</td>
        <td class="center-align"><data-availability-indicator :score="community[selectedMetricCategory.name]"></data-availability-indicator></td>
        <td class="center-align"><a target="_blank" :href="'/community-data-summary/' + community.gnis_feature_id + '/'"><i class="material-icons">arrow_forward</i></a></td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import DataAvailabilityIndicator from './DataAvailabilityIndicator.vue'
export default {
  name: 'community-list',
  computed: {
    ...mapState([
      'communityList',
      'selectedMetricCategory'
    ]),
    ...mapGetters([
      'communitiesForSelect'
    ])
  },
  methods: {
    checkboxClick: function (community) {
      if (!community.selected) {
        this.$store.dispatch('getMetricsForCommunity', community)
      }

      this.$store.commit({
        type: 'communityCheckbox',
        community: community
      })
    },
    clearSelection: function () {
      this.$store.commit({
        type: 'clearSelectedCommunities'
      })
    },
  },
  components: {
    DataAvailabilityIndicator
  }
}
</script>
<style>
  .checkbox_container {
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// CommunityList.vue?65db3e0d